import type { FieldErrors } from 'react-hook-form'
import { SelectField } from './SelectField'
import { occupations } from './occupations'
import { goalOptions } from './goalOptions'
import { frequencyOptions } from './frequencyOptions'
import { amountOptions } from './amountOptions'
import type { SurveyFormValues } from './surveyTypes'

type Props = {
    labels: {
        occupation: string
        investmentPurpose: string
        expectedTradeFrequency: string
        expectedTradeAmount: string
    }
    control: any
    setValue: any
    trigger: any
    errors: FieldErrors<SurveyFormValues>
    defaultValues?: Partial<SurveyFormValues>
    labelClassName?: string
}

export function SurveyFormFields({
    labels,
    control,
    setValue,
    trigger,
    errors,
    defaultValues,
    labelClassName = 'text-xs xs:text-sm',
}: Props) {
    return (
        <>
            <SelectField
                label={labels.occupation}
                fieldName="occupation"
                control={control}
                setValue={setValue}
                trigger={trigger}
                error={errors.occupation?.message ?? ''}
                items={occupations}
                defaultValue={defaultValues?.occupation}
                className={labelClassName}
            />
            <SelectField
                label={labels.investmentPurpose}
                fieldName="investmentPurpose"
                control={control}
                setValue={setValue}
                trigger={trigger}
                error={errors.investmentPurpose?.message ?? ''}
                items={goalOptions}
                defaultValue={defaultValues?.investmentPurpose}
                className={labelClassName}
            />
            <SelectField
                label={labels.expectedTradeFrequency}
                fieldName="expectedTradeFrequency"
                control={control}
                setValue={setValue}
                trigger={trigger}
                error={errors.expectedTradeFrequency?.message ?? ''}
                items={frequencyOptions}
                defaultValue={defaultValues?.expectedTradeFrequency}
                className={labelClassName}
            />
            <SelectField
                label={labels.expectedTradeAmount}
                fieldName="expectedTradeAmount"
                control={control}
                setValue={setValue}
                trigger={trigger}
                error={errors.expectedTradeAmount?.message ?? ''}
                items={amountOptions}
                defaultValue={defaultValues?.expectedTradeAmount}
                className={labelClassName}
            />
        </>
    )
}
